//highlight matches
function wrapper(element, matches, char_limit) {
  var nodeFilter = {
    acceptNode: function(node) {
      if (/^[\t\n\r ]*$/.test(node.nodeValue)) {
        return NodeFilter.FILTER_SKIP
      }
      return NodeFilter.FILTER_ACCEPT
    }
  }

  var index = 0,
    matches = matches.sort(function(a, b) {
      return a[0] - b[0]
    }).slice(),
    previousMatch = [-1, -1]
  match = matches.shift(),
    walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      nodeFilter,
      false
    )

  while (node = walker.nextNode()) {
    if (match == undefined) break
    if (match[0] == previousMatch[0]) continue

    var text = node.textContent,
      nodeEndIndex = index + node.length;

    if (match[0] + match[1] <= char_limit && match[0] + match[1] <= nodeEndIndex) {
      var range = document.createRange(),
        tag = document.createElement('mark'),
        rangeStart = match[0] - index
      rangeEnd = rangeStart + match[1];
      if (rangeEnd >= node.length) {
        rangeStart = rangeStart - 1
        rangeEnd = node.length
      }

      tag.dataset.rangeStart = rangeStart
      tag.dataset.rangeEnd = rangeEnd

      range.setStart(node, rangeStart)
      range.setEnd(node, rangeEnd)
      range.surroundContents(tag)
      index = match[0] + match[1]

      // the next node will now actually be the text we just wrapped, so
      // we need to skip it
      walker.nextNode()
      previousMatch = match
      match = matches.shift()
    } else {
      index = nodeEndIndex
    }
  }
}
